export default __webpack_public_path__ + "static/media/plus.98043b84.svg";